import { CountryCode } from '@csp/csp-common-model';
import { StudyContentService } from '../../service/StudyContentService';
import { TechnicalSupportEntryMapper } from '../../technical-support/mapper/TechnicalSupportEntryMapper';
import { TechnicalSupportEntry } from '../../technical-support/model/TechnicalSupportEntry';

export const getStudyTechnicalSupport = (countryCode: CountryCode): TechnicalSupportEntry => {
  const technicalSupport = StudyContentService.getTechnicalSupport();
  return TechnicalSupportEntryMapper.from(technicalSupport, countryCode);
};
